import React, { useRef } from "react";
import Fitur from "../Components/About";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import HeroSection from "../Components/Hero";
import PatunganCepat from "../Components/patunganCepat/patunganCepat";
import CarouselDonasi from "../Components/donasi/donasi";
import MudahBerbagiSteps from "../Components/ruteBerbagi/ruteBerbagi";
import FokusUtama from "../Components/FokusUtama/fokusUtama";
import ResponsiveBottomNavbar from "../Components/Navbar/bottomNavbar";

const HEADER_HEIGHT = 96;

const LandingPageUdin: React.FC = () => {
  const berandaRef = useRef<HTMLDivElement>(null);
  const fiturRef = useRef<HTMLDivElement>(null);
  const kategoriRef = useRef<HTMLDivElement>(null);
  const campaignRef = useRef<HTMLDivElement>(null);
  const fokusRef = useRef<HTMLDivElement>(null);

  const scrollToSection = (section: string) => {
    const sectionMap: Record<string, React.RefObject<HTMLDivElement | null>> = {
      beranda: berandaRef,
      fitur: fiturRef,
      kategori: kategoriRef,
      campaign: campaignRef,
      fokus: fokusRef,
    };

    const target = sectionMap[section];

    if (target?.current) {
      window.scrollTo({
        top: target.current.offsetTop - HEADER_HEIGHT,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="font-signika max-w-[1440px] mx-auto bg-[#f5f8f6]">
      {/* NAVBAR FIXED */}
      <div className="fixed top-0 left-0 w-full z-40">
        <Navbar scrollToSection={scrollToSection} />
      </div>

      {/* CONTENT */}
      <section className="pt-[96px]">
        <div ref={berandaRef}>
          <HeroSection />
        </div>

        <div ref={fiturRef}>
          <PatunganCepat />
        </div>

        <div ref={kategoriRef}>
          <Fitur />
        </div>

        <div ref={campaignRef}>
          <CarouselDonasi />
        </div>

        <div>
          <MudahBerbagiSteps />
        </div>

        <div ref={fokusRef}>
          <FokusUtama />
        </div>

        <Footer />

        <ResponsiveBottomNavbar />
      </section>
    </section>
  );
};

export default LandingPageUdin;
